module.exports = __webpack_public_path__ + "img/34_41.2539a496.png";